import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './style.css'

export default class Header extends Component {
  static propTypes = {
    companyName: PropTypes.string.isRequired,
    companyId: PropTypes.number.isRequired,
    logo: PropTypes.string.isRequired,
    mainColor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isCobbleDisplayed: PropTypes.bool.isRequired,
    redirectTo: PropTypes.func.isRequired
  }

  renderCompanyLogo (logo) {
    return (
      <div className='text-center col-md-4 d-none d-md-block'>
        <p className='header-text'>
          <img className='header-logo' src={logo} alt={this.props.companyName} />
        </p>
      </div>

    )
  }

  renderAppName (appName) {
    return (
      <div className='col-6 col-md-4'>
        <span>
          <i
            className='ico home-icon fa fa-home'
            aria-hidden='true'
            onClick={this.props.redirectTo}
            />
        </span>
        <span className='text-left app-name-text d-none d-sm-inline'>
          {appName}
        </span>
      </div>
    )
  }

  renderCobbleLogo () {
    return (
      <div className='col-6 col-md-4'>
        <div className='d-none d-sm-block'>
          <p className='text-right header-text cobble-text'>
            Propulsé par Cobble
          </p>
        </div>
        <div className='d-block d-sm-none'>
          <p className='text-right header-text cobble-text'>
            Par Cobble
          </p>
        </div>
      </div>
    )
  }

  render () {
    return (
      <div className='container-fluid top-bar' style={{backgroundColor: this.props.mainColor}}>
        <div className='row full-height top-bar-row'>
          {this.renderAppName(this.props.name)}
          {this.renderCompanyLogo(this.props.logo)}
          {this.props.isCobbleDisplayed && this.renderCobbleLogo()}
        </div>
      </div>
    )
  }
}
